import React from "react";
import localeText from "../../../../../locale";

const PartnerB2BEmptyState = () => (
  <div
    className="flex flex-column align-items-center justify-content-center p-6 border-round"
    style={{
      backgroundColor: "var(--theme-border, #eaeaea)",
      color: "var(--theme-text-muted, #5C5C5C)",
      minHeight: "200px",
    }}
  >
    <i className="pi pi-search text-5xl mb-3" />
    <p className="m-0 text-center">{localeText("partnerB2bEmptyState")}</p>
  </div>
);

export default PartnerB2BEmptyState;
